define('models/pages/wishlist/offers/wishlist-result',['require','underscore','chaplin','models/base/model'],function(require) {
    'use strict';

    var _ = require('underscore'),
        Chaplin = require('chaplin'),
        Model = require('models/base/model');


    var WishlistResult = Model.extend({
        idAttribute: 'id',
        urlPath: function() {
            var id = this.get(this.idAttribute);
            return '/api/wishlist-result' + (id ? ('/' + id) : '');
        },
        parse: function(item) {
            var dateReceived = new Date(item.dateReceived);
            item.dateReceived = dateReceived;

            item.filter = {
                date  : dateReceived.getDate(),
                month : dateReceived.getMonth(),
                year  : dateReceived.getFullYear()
            };

            return item;
        }
    });

    return WishlistResult;
});

